<template>
  <section id="simulator-loan" class="simulator">
    <div class="simulator__container">
      <div class="simulator__form">
        <div class="simulator__item required">
          <label for="saving">Capacité d'épargne mensuelle *</label>
          <input id="saving" type="number" placeholder="en euros" v-model="saving" @keyup.enter="calc">
        </div>
        <div class="simulator__item required">
          <label for="creditYears">Durée du crédit souhaitée *</label>
          <input id="creditYears" type="number" placeholder="en années" v-model="creditYears" @keyup.enter="calc">
        </div>
        <div class="simulator__item required">
          <label for="rate">Taux du prêt *</label>
          <input id="rate" type="number" placeholder="en %" v-model="rate" @keyup.enter="calc">
        </div>
        <ul v-if="errors.length" class="callout callout--error">
          <li v-for="error in errors">{{ error }}</li>
        </ul>
        <div class="simulator__actions">
          <button class="button" @click="calc">
            <span>Calculer</span>
          </button>
          <button class="link" @click="reset">
            <span class="link__txt">Réinitialiser</span>
          </button>
        </div>
      </div>

      <div id="borrowingCapacity" class="simulator-result" v-if="borrowingCapacity">
        <span class="simulator-result__title">Votre capacité d'emprunt (estimé)</span>
        <span class="simulator-result__money">{{ borrowingCapacity }}</span>
        <div class="simulator-result__legals">
          <p>Cette simulation est donnée à titre indicatif et n'a pas de valeur contractuelle.</p>
        </div>
      </div>

      <div class="simulator__legals">
        <span>* Ces champs sont obligatoires</span>
      </div>
    </div>
  </section>
</template >

<script>

  export default {
    name: "SimulatorLoan",
    data() {
      return {
        saving: '',
        creditYears: '',
        rate: '',
        borrowingCapacity: '',
        isResultVisible: false,
        errors: []
      };
    },
    methods: {
      calc: function () {

        this.errors = [];
        this.isResultVisible = false;

        if ( ! this.areFieldsFilled() )
          return;

        this.borrowingCapacity = Math.round(this.saving * 12 * ((Math.pow(1 + this.rate/100, this.creditYears) - 1) / (this.rate/100 * Math.pow(1 + this.rate/100, this.creditYears)))).toLocaleString('fr-FR') + ' €';

      },
      reset: function () {
        this.saving = '';
        this.creditYears = '';
        this.rate = '';
        this.borrowingCapacity = '';
        this.isResultVisible = false;
        this.errors = [];
      },
      areFieldsFilled: function () {

        if (this.saving && this.creditYears && this.rate)
          return true;

        if (!this.saving)
          this.errors.push('Veuillez indiquer votre capacité d\'épargne mensuelle.');
        if (!this.creditYears)
          this.errors.push('Veuillez indiquer la durée du crédit souhaitée.');
        if (!this.rate)
          this.errors.push('Veuillez saisir le taux de votre prêt.');

        return false;

      }
    }

  };
</script>

